module.exports = __webpack_public_path__ + "img/faq-splash.bc369082.svg";